import { FilterModel } from "app/models/FilterModel";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";

const useFilters = () => {
  const filterState = useSelector(
    (state: RootState) => state.filter.data,
    shallowEqual,
  );

  if (!filterState) {
    return null;
  }

  const filters: FilterModel = {
    orderby: filterState.orderby,
    tags: filterState.tags,
    type: filterState.type,
    from: filterState.from,
    to: filterState.to,
    userIds: filterState.userIds,
  };

  const filteredFilter: FilterModel | any = {};

  for (const [key, value] of Object.entries(filters)) {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        filteredFilter[key] = value;
      }
    } else if (typeof value === "object" && value !== null) {
      if (Object.values(value).some((innerValue) => innerValue !== false)) {
        filteredFilter[key] = value;
      }
    } else {
      if (value !== "" && value !== false) {
        filteredFilter[key] = value;
      }
    }
  }

  return { filters: filteredFilter };
};

export default useFilters;
